// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Distinct from the designer layout itself */

.tn-target-selected {
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
     border-top: 0px;
     color: #fff !important;
 }

.tn-target-selected svg{
    color: white !important;
}

.document>.document-heading.tn-target-selected>h4>a {
    color: #fff;
}

.tn-target-not-selected,
.tn-target {
    /* Marker classes for queries and events */
}


/* Jquery Dialog  */

.no-close .ui-dialog-titlebar-close {
    display: none;
}

.progress {
    margin-bottom: 0px;
    border-radius: 0px;
}

.document.ui-sortable-handle.ui-sortable-helper {
    height: 33px !important;
}

.progress-bar {
    width: 250px;
    height: 19px;
}

.progress-bar span, .help-center h1 {
    color: black;
}

.ranking_items {
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #fff;
}

.ranking_items tbody tr:nth-child(odd) {
    background-color: #F7F7F7
}

.ranking_items tbody td:hover {
    background-color: #B2E1FF;
}

.rankBtnActive {
    cursor: pointer;
}

.rankBtnInactive {
    cursor: not-allowed;
}

.v-slider {
    width: 4px;
    border: 1px solid #000;
    height: 100px;
    color: black;
    margin-bottom: -3px;
    position: relative;
    left: 75%;
    top: 5px;
}

.v-slider-tic {
    position: absolute;
    margin-left: -10px;
    display: block;
    width: 4px;
    height: 0px;
    border: 1px solid;
}

.v-slider-label {
    position: absolute;
    right: 17px;
}

.v-slider-label.max {
    bottom: 0px;
}

.v-slider-label.min {
    top: 0px;
}

.h-slider {
    width: 100px;
    border: 1px solid #000;
    height: 4px;
    color: black;
    margin-right: -5px;
    position: relative;
    left: 5px;
    top: 75%;
}

.h-slider .handle {
    position: absolute;
    bottom: 100%;
}

.h-slider .handle img {
    position: absolute;
}

.h-slider-tic {
    position: absolute;
    margin-top: -15px;
    display: block;
    width: 0px;
    height: 4px;
    border: 1px solid #000;
}

.h-slider-tic img {
    position: absolute;
}

.h-slider-label {
    position: absolute;
    margin-top: -37px;
}

.h-slider-label.max {
    right: 0px;
}

.h-slider-label.min {
    left: 0px;
}

.websignature-position-top {
    position: absolute;
    top: 0;
    width: 98%;
    border-bottom: solid 1px #000000;
}

.websignature-position-bottom {
    position: absolute;
    bottom: 0;
    width: 98%;
    border-top: solid 1px #000000;
}

.varrow {
    width: 0px;
    height: 0px;
    border-bottom: 7px solid transparent;
    border-top: 7px solid transparent;
    border-right: 12px solid #2f2f2f;
    position: absolute;
    border-radius: 5px;
    left: 15%;
    z-index: 10;
    top: 5px;
}

.harrow {
    width: 0px;
    height: 0px;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 12px solid #2f2f2f;
    position: absolute;
    border-radius: 5px;
    left: 0;
    z-index: 10;
    top: 0%;
}


/* Hidden Property Class Styles */

.hiddenProp {
    opacity: 0.5;
}


/* Style to be applied on the border of an invalid control */

.outOfBounds {
    overflow: hidden;
    border: 3px dashed red !important;
}


/*
BT - Start Changes
*/

.scroll-pane {
    overflow: auto;
    width: 99%;
    float: left;
    width: 4500px;
}


/*.scroll-content { width: 2440px; float: left; }*/

.scroll-content-item {
    width: 85px;
    height: 40px;
    float: left;
    margin: 10px;
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
    border: solid 1px;
    border-radius: 4px;
}

.scroll-bar-wrap {
    clear: left;
    padding: 0 4px 0 2px;
    margin: 0 -1px -1px -1px;
}

.scroll-bar-wrap .ui-slider {
    background: none;
    border: 0;
    height: 2em;
    margin: 0 auto;
}

.scroll-bar-wrap .ui-handle-helper-parent {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0 auto;
}

.scroll-bar-wrap .ui-slider-handle {
    top: .2em;
    height: 1.0em;
    background: none;
    background-color: #c0d382;
}

.scroll-bar-wrap .ui-slider-handle .ui-icon {
    margin: -8px auto 0;
    position: relative;
    top: 50%;
}

#factories {
    width: 100%;
}

.pf-control {
    display: block;
    position: absolute;
}

.pf-control-core {
    cursor: default;
    display: inline;
    float: left;
}

.size-handle-top,
.size-handle-bottom {
    display: block;
    height: 4px;
    background-color: transparent;
}

.size-handle-bottom {
    clear: both;
}

.size-handle-left,
.size-handle-right {
    display: inline;
    width: 4px;
    background-color: transparent;
}

.size-handle-left,
.size-handle-right,
.size-handle-top {
    position: absolute;
}

.size-handle-left,
.size-handle-top {
    left: 0px;
}

.size-handle-bottom {
    position: absolute;
    bottom: 0px;
}

.size-handle-right {
    right: 0px;
}

.drag-ghost {
    border: 1px #111111 dashed;
    background-color: transparent;
    position: absolute;
    left: -30000px;
    top: -30000px;
    z-index: 10000;
}

.propDetail {
    width: 100%;
    margin-bottom: 0;
    display: inline-block;
}

.propDetail label {
    font-weight: normal;
}

#pageAssets {
    position: fixed;
    bottom: 0px;
    left: 400px;
    margin-bottom: 5px;
    background: #fff;
}

.asset-control {
    float: left;
    padding: 5px;
    text-align: center;
    height: 50px;
    width: 50px;
}

.asset-control label {
    font-size: 10px;
    font-weight: normal;
}

.asset-control:hover {
    cursor: pointer;
    background-color: #c0d382 !important;
}

.control-movie {
    background: #000;
}

.prop-label {
    font-weight: bold;
}

.prop-sublabel {
    padding-top: 5px !important;
}

.prop-separator-radio {
	padding-top: 0 !important; 
	max-height: 16px;
}

#propNavPosition div.nav-position.prop-detail input[type="text"] {
    width: 42px;
}

.add_overflow_y {/*
	overflow-y: auto;
    overflow-x: hidden;*/
}

select {
    width: 100%;
    height: 25px;
    font-size: 11px;
    font-size: 1.1rem;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #bbb;
}


/* Spectrum Override */

.sp-preview {
    position: relative;
    width: 12px;
    height: 21px;
    border: solid 1px #222;
    margin-right: 0px;
    float: left;
    z-index: 0;
}

.sp-replacer {
    border-radius: 4px;
    padding: 2px;
}

.sp-dd {
    padding: 2px 0;
    height: 16px;
    line-height: 16px;
    float: left;
    font-size: 10px;
    display: none;
}

.themeTextRows {
    /* padding-left: 15px; */
}

.themeTextRows .style-font-size, .themeTextRows .style-border-size {
    width: 41px !important;
}

.themeTextRows .style-font {
    width: 80px;
}

.themeTextRows label {
    font-weight: normal;
}

.weightSelector,
.styleSelector {
    border: 1px solid #bbb;
    border-radius: 4px;
    height: 32px;
    width: 25px;
}

.themeTextRows .style-border-size,
.themeTextRows .style-border-radius {
    width: 50px;
}

.property-tabs .tab-pane {
    width: 460px;
}

.ui-dialog {
    z-index: 999999;
}

.ui-dialog-titlebar {
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
    /* IE6-9 */
    border-top: 0px;
    color: #fff;
}

.common-group-list {
    width: 40%;
    height: 480px;
    padding: 0px;
    border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    border: 1px solid #d5d5d5;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    color: #333;
    font-family: "Roboto", "sans-serif";
    font-weight: 400;
    overflow-y: auto;
}

.common-group-list ul {
    padding: 0px;
    margin: 2px;
}

.common-group-list li {
    list-style-type: none;
}

.common-group-list li:hover,
.search-item:hover {
    cursor: pointer;
}

.common-group-list div,
.search-item {
    background: #fcfcfc;
    background: -moz-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);
    background: -webkit-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);
    background: linear-gradient(to bottom, #fcfcfc 0%, #eeeeee 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee', GradientType=0);
    border: 1px solid #d5d5d5;
    box-shadow: 0px 2px 5px #d5d5d5;
    -moz-box-shadow: 0px 2px 5px #d5d5d5;
    -webkit-box-shadow: 0px 2px 5px #d5d5d5;
    height: 25px;
    padding: 4px;
    font-size: 11px;
}

ul.clone-helper > li {
    list-style: none;
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
    border: 1px solid #d5d5d5;
    width: 200px;
    height: 35px;
    padding: 4px;
}

.common-group-list div.selected
{
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}

.common-group-list div:hover,
.search-item:hover {
    background: #d8f1a8 !important;
    background: -moz-linear-gradient(top, #d8f1a8 0%, var(--main-secondary) 100%) !important;
    background: -webkit-linear-gradient(top, #d8f1a8 0%, var(--main-secondary) 100%) !important;
    background: linear-gradient(to bottom, #d8f1a8 0%, var(--main-secondary) 100%) !important;
}

.thumb.ui-widget-header.selected {
    border-radius: 4px;
    outline: 1px dashed black;
}

.asset div.selected {
    border-radius: 4px;
    outline: 1px dashed black;
}

/* File Input */

.inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.inputfile+label {
    width: 100%;
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 11px;
    line-height: 1.42857143;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background: #fcfcfc;
    background: -moz-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);
    background: -webkit-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);
    background: linear-gradient(to bottom, #fcfcfc 0%, #eeeeee 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee', GradientType=0);
    border: 1px solid #d5d5d5;
    box-shadow: 0px 2px 5px #d5d5d5;
    -moz-box-shadow: 0px 2px 5px #d5d5d5;
    -webkit-box-shadow: 0px 2px 5px #d5d5d5;
    color: #333;
    font-weight: 700;
}

.inputfile:focus+label,
.inputfile+label:hover {
}

.inputfile+label {
    cursor: pointer;
    /* "hand" cursor */
}

.inputfile:focus+label {
    outline: 1px dotted #000;
    outline: -webkit-focus-ring-color auto 5px;
}


/* File Input */

.list-group-item {
    border: none;
    padding: 5px 0px;
}

#report-form-dialog {
    overflow: hidden;
    padding-right: 0px;
}

#dbPanelOne ul,
#dbPanelTwo ul {
    margin: 0.75em 0;
    padding: 0 1em;
}

#dbPanelOne>ul>li.list-group-item.node-dbPanelOne.node-selected,
#dbPanelTwo>ul>li.list-group-item.node-dbPanelTwo.node-selected {
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
    border-top: 0px;
    color: #fff!important;
}

#select-field-dialog .page-icon,
#filterResults .page-icon {
    margin-right: 10px;
}

#select-field-dialog ul {
    margin: 0.75em 0;
    padding: 0 1em;
    list-style: none;
}

#select-field-dialog li.collapsible:before,
#filterResults li.collapsible:before {
    content: "";
    width: 10px;
    height: 10px;
    border-right: 0;
    border-top: 0.35em solid transparent;
    border-left: 0.45em solid #000;
    border-bottom: 0.35em solid transparent;
    display: block;
    left: -1em;
    top: 1.1em;
    position: relative;
}

#select-field-dialog li.collapsible.open:before,
#filterResults li.collapsible.open:before {
    border-bottom: 0;
    border-left: 0.35em solid transparent;
    border-right: 0.35em solid transparent;
    border-top: 0.45em solid #000;
}

#select-field-dialog a.field-select.selected,
#filterResults a.field-select.selected {
    font-weight: bold;
    color:  var(--main-primary);
}

#select-field-dialog a.field-list-toggle.selected {
    font-weight: bold;
    color:  var(--main-primary);
}

#dialog ul.select-list a.selected{
    font-weight: bold;
    color:  var(--main-primary);
    text-decoration: underline;
}

.page-list.collapsible .control-list {
    display: none;
}

.page-section a.selected {
    color: #fff !important;
}

#select-field-dialog a:focus,
#filterResults a:focus {
    text-decoration: none;
}

#select-field-dialog a:hover,
#filterResults a:hover {
    text-decoration: none;
    color:  var(--main-primary);
}

#filterResults a {
    color: #000000;
}

.tt-dataset {
    background: white;
    width: 260px;
    padding: 5px;
    border-radius: 4px;
    height: 200px;
    border: 1px solid #d5d5d5;
}

.search-item i {
    float: left;
    margin-right: 5px;
}

.search-item div {
    float: left;
}

#shared-settings-dialog .row {
    margin: 10px 0;
    padding: 0;
}

#propSharedSettingsLink a:hover {
    cursor: pointer;
}

select:disabled {
    color: #bbb;
}

input:disabled,
textarea:disabled {
    background-color: #ddd;
}

#hideGrid,
#designerNonVisualObjects,
#designerObjectMarkers,
#designerWorkflowMarkers,
#designerSnapToGrid,
#designerSnapTextToNeighbor,
#designerToolbar,
#designerPropertyBar,
#designerHelpCenter,
#designerHelpGuide,
#designerObjectMarkers {
    /* font-size: 11px; */
}

.tabs-label {
    padding-left: 0px;
    padding-top: 40px;
}

.nav-tabs.nav-right>li {
    float: right;
}

.small-title>.ui-dialog-titlebar {
    font-size: x-small;
}

.disabledLink {
    color: grey !important;
}

.disabledPanel {
    pointer-events: none;
    opacity: 0.4 !important;
}

.disabledSection {
    pointer-events: none;
    opacity: 0.4;
}

.behavior-instance-tab {
    float: left;
    padding: 5px;
    height: 30px;
    min-width: 50px;
    margin-left: 5px;
    background: #fff;
}

.behavior-instance-tab.active {
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
    border-top: 0px;
    color: #fff;
}

.behavior-instance-close-img {
    float: right;
    font-size: 8px;
    cursor: pointer;
    padding-left: 5px;
}

#behavior-tabs {
    position: fixed;
    bottom: 0px;
    left: 400px;
    margin-bottom: 5px;
}

.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
    border: 1px solid #67b021/*{borderColorHighlight}*/
    !important;
    background: #67b021/*{bgColorHighlight}*/
    !important;
    color: #363636/*{fcHighlight}*/
    ;
}

#dialog-form .row {
    margin: 3px 0;
    padding: 0;
}

.formula-item {
    font-size: 11px;
}

.formula-item.active,
.formula-group.active,
.formula-function.active {
    background: #cecece;
}

.formula-item:hover {
    cursor: pointer;
}

.formula-function-item {
    font-style: italic;
}

.formula-function-item,
.formula-function-item+div.formula-item {
    margin-left: 15px;
}

.customized-text-area {
    min-height: 40px !important;
    font-size: smaller !important;
    padding-right: 45px;
}

#property-tabs input.color-picker-text {
    width: 55px;
    padding-left: 1px !important;
}

li.object-selector:hover,
li.behavior-selector:hover {
    cursor: pointer;
}

textarea {
    resize: none;
}

#select-field-dialog ul {
    font-size: 1.1rem;
}

.badges-container {
    position: absolute;
    left: -5px;
    top: -5px;
    opacity: 0.7;
}

.no-mobile-badge-container {
    display: none;
}

.mobile-badge-container {
    position: absolute;
    left: 0;
    top: -5px;
    background:  var(--main-primary);
    border-radius: 50%;
    height: 20px;
    width: 20px;
    margin-top: 1px;
    opacity: 0.7;
    z-index: 999;
}

.badges-container ul {
    list-style: none;
}

.badges-container ul li {
    float: left;
}

.pf-badge.mobile-badge.mobile-badge-mandatory {
     position: absolute;
     width: 15px;
     top: 3px;
     left: 7px;
}

.pf-badge.mobile-badge.mobile-badge-normal {
    position: absolute;
    width: 15px;
    top: 4px;
    left: 3px;
}


.pf-badge.mobile-badge.mobile-badge-hidden {
    position: absolute;
    width: 15px;
    top: 3px;
    left: 3px;
}

.pf-badge.mobile-badge.mobile-badge-disabled {
    position: absolute;
    width: 15px;
    top: 3px;
    left: 4px;
}

.pf-badge.mobile-badge.mobile-badge-readonly {
    position: absolute;
    width: 15px;
    top: 3px;
    left: 4px;
}

.twitter-typeahead {
    display: block;
}

.pf-selectable.group {
    border: 0px transparent dashed;
}

.pf-selectable {
    border: 0px transparent dashed;
    overflow: hidden;
}

.pfSelected {
    /* PF-3463: Image is being used instead of plain CSS classes due the following reason:
      "It was used to draw border with css for that select box,
      but it was outside the rectangle caused by protruding select handles. 
      So it was opted to use the image."
    */
    /*border: 1px #111111 dashed !important;;*/
    /*border: 1px solid;
    border-image: -webkit-linear-gradient(left, #000, #FFF, #000 33%, #FFF, #000 66%, #000,#FFF,#000) 4%; 
    border-image: -ms-linear-gradient(left, #000, #FFF, #000 33%, #FFF, #000 66%, #000,#FFF,#000) 4%; 
    border-image: -moz-linear-gradient(left, #000, #FFF, #000 33%, #FFF, #000 66%, #000,#FFF,#000) 4%;*/
    /*
    border-style: solid !important;
    border-width: 1px !important;
    -moz-border-image: url(../images/common/resize-border.png) 8 8 repeat !important;
    -webkit-border-image: url(../images/common/resize-border.png) 8 8 repeat !important;
    -o-border-image: url(../images/common/resize-border.png) 8 8 repeat !important;
    border-image: url(../images/common/resize-border.png) 8 8 repeat !important;
    border: .1rem #000000 dashed !important;
    */

    /* PF-2381: Using outline instead of image for showing selected control's borders on editor layout */
    outline: 1px dashed black;
}

.pfSelectedBlue, .nav-position input:focus, .prop-detail input:focus, .nav-position select:focus, .prop-detail select:focus {
    border: 1px dodgerblue solid !important;
}

.pfSelected.reverseBorder {
    border: 1px #ffffff dashed !important;
}

.wordwrap {
    /* white-space: pre-wrap;*/
    /* CSS3 */
    white-space: -moz-pre-wrap;
    /* Firefox */
    white-space: -o-pre-wrap;
    /* Opera 7 */
    word-wrap: break-word;
    /* IE */
}

#deleteFormulaItem:hover,
#formulaUp:hover,
#formulaDown:hover {
    cursor: pointer;
}

#thumb-pages li.selected>a,
#document-1 li.selected>a,
div.listSelected ul.select-list li.selected {
    color:  var(--main-primary);
    font-weight: bold;
}

#segrip {
    right: -5px;
    bottom: -5px;
    height: 9px;
    width: 9px;
}

.document-heading {
    cursor: pointer;
}

#aPageSel {
    position: absolute;
    left: 0 ;
    top: 0;
}

#aPage {
    position: relative;
    overflow: hidden;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    border-style: solid;
    border-width: 0px;
    margin-bottom: 5px; 
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
}

.formBoxShadow {
    box-shadow: 5px 5px 5px #BBB;
}




#recentEdits .list li:hover, #recentEditsEFD .list li:hover, #recentEditsVFD .list li:hover, #favoriteForms .list li:hover {
    cursor: pointer;
    color: #ffffff;
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}

.listSelected .list li:hover, #recentEditsEFD .list li:hover, #recentEditsVFD .list li:hover {
    cursor: pointer;
    color: #ffffff;
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}

.inputTextWithLabel{
    width: 42px !important;
}

.maskTextLabel{
    width: 12px;
    height: 16px;
    text-align: center;
}

.maskTextLabelContainer{
    padding-top: 3px ;
    padding-left: 4px;
}

.no-spin-stepper::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
    -moz-appearance:textfield !important;
}

.table-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.search-results-ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.control-list-container, div.page-list.selected {
    background: var(--main-primary) !important;
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
    border-top: 0px;
    color: #fff!important;
}

div.page-list.selected > a.selected{
    color:#fff!important;
}

div.control-list-container > a {
    color: #fff!important;
    font-weight: bold;
    vertical-align: middle;
}

li.control-list-container > ul {
    background-color: #fff;
    margin-left: -10px!important;
    margin-bottom: -1px!important;
}

div.control-list-container i {
    padding-top: 2px;
    padding-bottom: 1px;
}

.select-field-header{
    padding-left: 5px;
}

.select-field-header.selected span{
    color: #ffffff;
}

.selectedGroup{
    color: var(--main-primary)!important;
    font-weight: bold;
}

.control-list li {
    padding-left: 4px !important;
    padding-top: 1px;
    padding-bottom: 1px;
    vertical-align: middle !important;
}

.selected .field-select:hover {
    color: #fff;
}

.field-list-toggle.field-select.selected{
    color: #000000;
}
/* CLASSES FOR MOBILE VERSION*/

.highlight {
    font-weight: bold;
    color: black;
}
.no-highlight {
    font-weight: normal;
    color: gray;
}

.large-icon {
    font-size: 40px;
    cursor: pointer;
}

.pf-section-control.pfSelected .pf-drag,
.pf-section-control .pf-drag:hover {
    color:  var(--main-primary) !important;
}

.ui-sortable-placeholder.ui-state-default {
    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}


.mobile-section-content .pf-control.control-container {
    width: 100% !important;
    height: calc(100% - 2px) !important;
    top: inherit !important;
    left: inherit !important;
    display: inline-block;
}

.hideBodySection {
    display: none !important;
}

.mobile-column-content {
    list-style: none;
    margin: 0;
    padding: 0;
}

.slide-placeholder {
    background: linear-gradient(var(--gradient-ToBottom));
    position: relative;
}
.slide-placeholder:after {
    content: " ";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 15px;
    background: transparent;
}

/* Datepicker styles */
#aPage .ui-datepicker .ui-datepicker-header {
	position: relative;
	padding: .2em 0;
}
#aPage .ui-datepicker .ui-datepicker-prev,
#aPage .ui-datepicker .ui-datepicker-next {
	position: absolute;
	top: 2px;
	width: 1.8em;
	height: 1.8em;
}
#aPage .ui-datepicker .ui-datepicker-prev {
	left: 2px;
}
#aPage .ui-datepicker .ui-datepicker-next {
	right: 2px;
}
#aPage .ui-datepicker .ui-datepicker-prev span,
#aPage .ui-datepicker .ui-datepicker-next span {
	display: block;
	position: absolute;
	left: 50%;
	margin-left: -8px;
	top: 50%;
	margin-top: -8px;
}
#aPage .ui-datepicker .ui-datepicker-title {
	margin: 0 2.3em;
	line-height: 1.8em;
	text-align: center;
}
#aPage .ui-datepicker .ui-datepicker-title select {
	font-size: 1em;
	margin: 1px 0;
	height: 25%;
}
#aPage .ui-datepicker select.ui-datepicker-month,
#aPage .ui-datepicker select.ui-datepicker-year {
	width: 45%;
	border-radius: 0px! important;
}
#aPage .ui-datepicker table {
	width: 100%;
	font-size: .9em;
	border-collapse: collapse;
	margin: 0 0 .4em;
	height: 80%;
}
#aPage .ui-datepicker th {
	padding: .7em .3em;
	text-align: center;
	font-weight: bold;
	border: 0;
}
#aPage .ui-datepicker td {
	border: 0;
	padding: 1px;
}

#aPage .ui-datepicker .ui-datepicker-title {
	line-height: 3.3em !important;
}
#aPage .ui-datepicker .ui-datepicker-prev span, 
#aPage .ui-datepicker .ui-datepicker-next span {
	top: 80% !important;
}
#aPage .ui-datepicker .ui-datepicker-prev {
	left: 5px !important;
}
#aPage .ui-datepicker .ui-datepicker-next {
	right: 5px !important;
}
#aPage .ui-datepicker select.ui-datepicker-month {
	width: 41% !important;
	text-align: center;
	margin: 3px;
}
#aPage .ui-datepicker select.ui-datepicker-year {
	width: 45% !important;
	text-align: center;
	margin: 3px;
}
#aPage .ui-datepicker {
	padding: 0;
	display: none;
	background-color: white;
	font-size: 9px;
	z-index: 16777271 !important;
}
#aPage .ui-datepicker .ui-datepicker-header {
	position: relative;
	padding: 0;
	background-color: #E3E3E3;
	border-radius: 0 0 0 0;
	border-style: none none solid;
	border-width:
	0 0 1px; 
}
#aPage .dateCalendar .ui-datepicker-calendar a, 
#aPage .dateinputpicker .ui-datepicker-calendar a {
	border: none;
	background: #ffffff;
}
#aPage .ui-datepicker th {
	font-family:Sans-Serif;
	font-size:11px;
}
#aPage .ui-datepicker td {
	padding: 0px !important;
}
#aPage .ui-datepicker {
	width: 100%;
	height: 100%;
	border-bottom: none;
	background-color: #ffffff;
	color: #333333;
	border: none;
}
#aPage .ui-datepicker th {
	line-height: 16px;
	font-size: 10px !important;
	font-family: sans-serif !important;
	color: #333333;
	background-color: transparent;
	padding: 2px!important;
}

#aPage .ui-datepicker select.ui-datepicker-month,
#aPage .ui-datepicker select.ui-datepicker-year {
	color: #333333;
	font-family: sans-serif !important;
}
#aPage .ui-datepicker td span,
#aPage .ui-datepicker td a {
	background-color: transparent !important;
	color: #333333;
	font-size: 10px!important;
	font-family: sans-serif !important;
	font-weight: normal !important;
	line-height: 16px;
	text-align: center;	
	border: 0 !important;
}

#aPage .ui-datepicker td a.ui-state-highlight {
    background-color: #f89b3c !important;
}
/* End of Datepicker styles */


/* MODAL DIALOGS */

.dialog-container{
    padding: 10px 5px 10px 5px !important;
    border: 1px solid #ccc !important;
    border-width: thin !important;
    border-radius: 10px !important;
    box-shadow: 0 2px 9px rgba(0,0,0,.4) !important;
}


/* GREETING MODAL */

#dialog-greeting{
    padding: 20px 20px 10px 20px!important;
}

#dialog-greeting .welcome-options{
	padding: 15px; 
    text-align: center;
    box-shadow: 0 2px 9px rgba(0,0,0,.4) !important;
    border-radius: 25px;
    height: 225px;
    margin-right: 10px;
    margin-left: 10px;
    cursor:pointer;
    transition: box-shadow 300ms ease-in-out;
}

#dialog-greeting .welcome-options:hover{
    box-shadow: 0 2px 12px var(--main-primary) !important;
}

#dialog-greeting .row{
    margin: 0!important;
}

.greeting-button {
    border-bottom-style: double;
    border-right-style: double;
    border-color:#f0fdff;
    border-radius: 15px;
    background-color: var(--mobile-buttons);
    color: white;
    width: 100px;
    margin-top: 10px;
    height: 25px;
    box-shadow: 1px 1px 1px #888888;
    float: right;
    font-size: 12px;
    padding-top: 3px;
}

.greeting-button h5{
    margin-bottom: 0px;
    font-size: 13px;
    margin-top: 0px;
    
}
.greeting-button-column{
    text-align: center;
}

.greeting-container {
    display: flex; 
    align-items: center; 
    justify-content: center;
    width: 100%;
    margin: 0 auto; 
    padding-bottom: 20px; 
    margin-top: 25px;
}

.greeting-container img {
    width: 80px;    
    height: 80px;
    cursor: pointer
}

/* TRIAL EXPIRED MODAL */

.trial-request-button {
    color: white;
    width: 145px;
    margin-top: 10px;
    height: 37px;
    margin: auto;
    font-size: 12px;
    display: block;
    font-weight: bold;
    border-radius: 5px;
    border: 1px solid #F89B3C;
    background: #F89B3C;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.trial-back-button {
    color: black;
    width: 145px;
    margin-top: 10px;
    height: 37px;
    margin: auto;
    font-size: 12px;
    display: block;
    font-weight: bold;
    border-radius: 5px;
    border: 1px solid #f0f0f0;
    background: #f0f0f0;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.trial-expired-button-container {
    padding-top: 8px;
    padding-bottom: 8px;
}

.trial-expired-link {
    color: #f99f4b !important;
    font-weight: bold;
}

/* HELP CENTER */

#dialog-help-center{
    padding: 10px 5px 10px 5px !important;
    border: 1px solid #ccc !important;
    border-width: thin !important;
    border-radius: 10px !important;
    box-shadow: 0 2px 9px rgba(0,0,0,.4) !important;

}

#dialog-help-center .inner-container-help{
    padding: 0 5px 5px 5px !important;
    margin: 10px !important;
}

#dialog-help-center .title_help_center {
    margin-bottom: 25px !important;
    font-size: 2.5rem !important;
    text-align: left !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    color: #333 !important;
    
}

#dialog-help-center .title-bar {  
    font-weight: 500 !important;
}

#helpContent{
    margin: 0px !important;
}

#helpContent .title-bar, .title-bar, .inner-container-help .title-bar{

    background-image: -moz-linear-gradient(var(--gradient)) !important;
    background-image: -webkit-linear-gradient(var(--gradient)) !important;
    background-image: linear-gradient(var(--gradient-ToBottom)) !important;
  
    border-radius: 5px;
    color: #fff !important;
    font-size: 20px !important;
    padding: 5px 0 5px 20px !important;
    width: 100%;
    font-family:"Roboto", "sans-serif";
    margin-top: 15px !important;
    margin-bottom: 15px !important;
}
.helpCenterDialog{
    border:0 !important;
    padding: 0 !important;
    border-radius: 10px;
}
.help-center{
    font-size: 12px;
}
.help-center button.greeting-button{
    width: 100px !important;
    margin: 0;
    height: 25px !important;
}

.sub_topic_help{
    font-weight: 700 !important;
    font-size: 14px !important;
    font-style:normal !important;
    font-family: "Roboto", "sans-serif" !important;
    text-align: left !important;
    color: #333 !important;
}

#helpContent svg{
    width: 23px;
    height: 19px;
    fill: var(--main-primary) ;
    cursor: pointer;
}

#helpContent .link{
    margin-left:20px!important;
}

.layout-toolbar-pane-label{
    margin-top: -5px;
    font-size: 0.4em;
    font-weight: 500;
}

.inline-help{
    width: 20px;
    display: inline-flex;
    padding: 5px 7px 5px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    border: 2px solid #F89B3C;
    height: 20px;
    margin: 0 5px;
    color: #F89B3C;
    font-weight: bolder;
    font-size: 15px;
    cursor: pointer;
}

/* Tooltip container */
.pa-tooltip {
    position: relative;
}
  
  /* Tooltip text */
  .pa-tooltip .tooltiptext {
    visibility: hidden;
    width: 250px;
    color: #000;
    text-align: left;
    padding: 10px;
    border-radius: 4px;
    border: 2px solid var(--accent-color);
    background: #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    bottom: 25px;
    left: 50%;
    margin-left: -125px; /* Use half of the width, to center the tooltip */
    position: absolute;
    z-index: 1;
    font-weight: normal;
    font-family: Poppins;
    font-size: 12px;
  }
  
  /* Show the tooltip text when you mouse over the tooltip container */
  .pa-tooltip:hover .tooltiptext {
    visibility: visible;
  }

  /* bottom arrow */
  .pa-tooltip .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--accent-color) transparent transparent transparent;
  }
#activeBehaviors{
    height:0px; 
    background-color: #F4F4F4; 
    margin-top: 3px;
}

.current-behavior{
    color: #808080;
    font-family: 'Roboto';
    margin: 8px 10px;
    font-weight: 500;
}



.behaviors-list{
    min-width: 200px;
    height: auto;
    background-color: #F9F9F9;
    position: absolute;
    bottom: 44px;
    right: 14px;
    float: right;
    display: none;
    z-index: 90000;
    padding: 10px;
    border-radius: 5px 5px 0px 5px;
    border: 1px solid #D6D6D6;
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
}

#activeBehaviorsButton{
    display: none;
}

.activeBehaviors{
    cursor: pointer;
    width: 40px;
    float: right;
    border-radius: 5px;
    margin-right: 2px;
    padding: 0 12px;
    margin-top: -2px;
}

.activeBehaviors span{
    font-size: 2.8em;
    rotate: 90deg;
    text-shadow: 0 1px 2px rgba(0,0,0,.6);
    margin-top: -2px;
}

.activeBehaviors.active{
    color: white;
	background: var(--main-primary) !important;
	background-image: -moz-linear-gradient(var(--gradient)) !important;
	background-image: -webkit-linear-gradient(var(--gradient)) !important;
	background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}

.activeBehaviors:hover{
    color: white;
	background: var(--main-primary) !important;
	background-image: -moz-linear-gradient(var(--gradient)) !important;
	background-image: -webkit-linear-gradient(var(--gradient)) !important;
	background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}

.behavior-item{
    min-width: 315px;
    height: 62px;
    background: #F4F4F4;
    padding: 10px;
    color: #2D2D2D;
    font-family: Poppins;
    margin: 5px 0;
    border-radius: 5px;
   
}

.behavior-item .behavior-name{
    font-weight: 500;
}

.behavior-item .behavior-breadcrumb{
    font-size: 12px;
    font-weight: 500;
    color: #898989;
}

.behavior-item:hover{
    background: #EEE;
    cursor: pointer;
   
}
.behaviors-list .close-behaviors{
    margin: 10px 5px;
    text-align: right;
    color: #799F3F;
    font-weight: 700;
    line-height: normal;
}

.behaviors-list .close-behaviors:hover{
    text-decoration: underline;
    cursor: pointer;
}

.behaviors-list .close-icon{
    text-align: right;
    float: right;
    display: none;
}

.behavior-item:hover .close-icon {
    display: block;
}

.behaviorLinkToDesigner{
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./assets/style/designer.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;IACI,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;KACrE,eAAe;KACf,sBAAsB;CAC1B;;AAED;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,0CAA0C;AAC9C;;;AAGA,mBAAmB;;AAEnB;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,OAAO;AACX;;;AAGA,iCAAiC;;AAEjC;IACI,YAAY;AAChB;;;AAGA,4DAA4D;;AAE5D;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;;AAGA;;CAEC;;AAED;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,aAAa;AACjB;;;AAGA,kDAAkD;;AAElD;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,UAAU;IACV,6BAA6B;AACjC;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA,iBAAiB;;wBAEO;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;;AAGA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;IACtE,UAAU;IACV,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,+DAA+D;IAC/D,kEAAkE;IAClE,gEAAgE;IAChE,oHAAoH;IACpH,yBAAyB;IACzB,+BAA+B;IAC/B,oCAAoC;IACpC,uCAAuC;IACvC,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;IACtE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;AAC1E;;AAEA;;IAEI,8BAA8B;IAC9B,wFAAwF;IACxF,2FAA2F;IAC3F,yFAAyF;AAC7F;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,eAAe;;AAEf;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,+DAA+D;IAC/D,kEAAkE;IAClE,gEAAgE;IAChE,oHAAoH;IACpH,yBAAyB;IACzB,+BAA+B;IAC/B,oCAAoC;IACpC,uCAAuC;IACvC,WAAW;IACX,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,0CAA0C;AAC9C;;;AAGA,eAAe;;AAEf;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;IACtE,eAAe;IACf,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,8BAA8B;IAC9B,uCAAuC;IACvC,cAAc;IACd,UAAU;IACV,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,qCAAqC;IACrC,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;;IAEI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;;;;;;;;;;IAWI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;IACtE,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;IAGI;cACU;IACV;cACU;IACV;IACA;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,4BAA4B;AAChC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;KACK,kBAAkB;KAClB,WAAW;KACX,QAAQ;KACR,SAAS;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;AACb;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI;;;;KAIC;IACD,0CAA0C;IAC1C;;;uGAGmG;IACnG;;;;;;;;KAQC;;IAED,oGAAoG;IACpG,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,SAAS;IACT,0BAA0B;IAC1B,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,qBAAqB;IACrB,OAAO;AACX;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;IAGI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;;;;AAKA;IACI,eAAe;IACf,cAAc;IACd,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;AAC1E;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;AAC1E;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;IACtE,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;AACA,8BAA8B;;AAE9B;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;AAC1E;;;AAGA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qDAAqD;IACrD,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,uBAAuB;AAC3B;;AAEA,sBAAsB;AACtB;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,aAAa;AACd;AACA;CACC,SAAS;AACV;AACA;CACC,UAAU;AACX;AACA;;CAEC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,QAAQ;CACR,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,aAAa;CACb,WAAW;AACZ;AACA;;CAEC,UAAU;CACV,6BAA6B;AAC9B;AACA;CACC,WAAW;CACX,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,SAAS;AACV;AACA;CACC,SAAS;CACT,YAAY;AACb;;AAEA;CACC,6BAA6B;AAC9B;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,4BAA4B;AAC7B;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,yBAAyB;CACzB,sBAAsB;CACtB,6BAA6B;CAC7B;QACO;AACR;AACA;;CAEC,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,cAAc;AACf;AACA;CACC,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;CACd,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,0BAA0B;CAC1B,kCAAkC;CAClC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;AACvB;;AAEA;;CAEC,cAAc;CACd,kCAAkC;AACnC;AACA;;CAEC,wCAAwC;CACxC,cAAc;CACd,yBAAyB;CACzB,kCAAkC;CAClC,8BAA8B;CAC9B,iBAAiB;CACjB,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;IACI,oCAAoC;AACxC;AACA,6BAA6B;;;AAG7B,kBAAkB;;AAElB;IACI,qCAAqC;IACrC,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,+CAA+C;AACnD;;;AAGA,mBAAmB;;AAEnB;IACI,sCAAsC;AAC1C;;AAEA;CACC,aAAa;IACV,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;;AAEnB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA,wBAAwB;;AAExB;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,gBAAgB;;AAEhB;IACI,qCAAqC;IACrC,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,+CAA+C;;AAEnD;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;;AAE1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,kEAAkE;IAClE,qEAAqE;IACrE,sEAAsE;;IAEtE,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,kCAAkC;IAClC,WAAW;IACX,kCAAkC;IAClC,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;IAC9C,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;AACtB;;EAEE,iBAAiB;EACjB;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,+CAA+C;IAC/C,YAAY;IACZ,SAAS;IACT,mBAAmB,EAAE,iDAAiD;IACtE,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;EACjB;;EAEA,oEAAoE;EACpE;IACE,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,YAAY;IACZ,kBAAkB;IAClB,SAAS,EAAE,iCAAiC;IAC5C,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,qEAAqE;EACvE;AACF;IACI,UAAU;IACV,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,YAAY;CACf,0CAA0C;CAC1C,kEAAkE;CAClE,qEAAqE;CACrE,sEAAsE;AACvE;;AAEA;IACI,YAAY;CACf,0CAA0C;CAC1C,kEAAkE;CAClE,qEAAqE;CACrE,sEAAsE;AACvE;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;;AAEnB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/* Distinct from the designer layout itself */\r\n\r\n.tn-target-selected {\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n     border-top: 0px;\r\n     color: #fff !important;\r\n }\r\n\r\n.tn-target-selected svg{\r\n    color: white !important;\r\n}\r\n\r\n.document>.document-heading.tn-target-selected>h4>a {\r\n    color: #fff;\r\n}\r\n\r\n.tn-target-not-selected,\r\n.tn-target {\r\n    /* Marker classes for queries and events */\r\n}\r\n\r\n\r\n/* Jquery Dialog  */\r\n\r\n.no-close .ui-dialog-titlebar-close {\r\n    display: none;\r\n}\r\n\r\n.progress {\r\n    margin-bottom: 0px;\r\n    border-radius: 0px;\r\n}\r\n\r\n.document.ui-sortable-handle.ui-sortable-helper {\r\n    height: 33px !important;\r\n}\r\n\r\n.progress-bar {\r\n    width: 250px;\r\n    height: 19px;\r\n}\r\n\r\n.progress-bar span, .help-center h1 {\r\n    color: black;\r\n}\r\n\r\n.ranking_items {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    background-color: #fff;\r\n}\r\n\r\n.ranking_items tbody tr:nth-child(odd) {\r\n    background-color: #F7F7F7\r\n}\r\n\r\n.ranking_items tbody td:hover {\r\n    background-color: #B2E1FF;\r\n}\r\n\r\n.rankBtnActive {\r\n    cursor: pointer;\r\n}\r\n\r\n.rankBtnInactive {\r\n    cursor: not-allowed;\r\n}\r\n\r\n.v-slider {\r\n    width: 4px;\r\n    border: 1px solid #000;\r\n    height: 100px;\r\n    color: black;\r\n    margin-bottom: -3px;\r\n    position: relative;\r\n    left: 75%;\r\n    top: 5px;\r\n}\r\n\r\n.v-slider-tic {\r\n    position: absolute;\r\n    margin-left: -10px;\r\n    display: block;\r\n    width: 4px;\r\n    height: 0px;\r\n    border: 1px solid;\r\n}\r\n\r\n.v-slider-label {\r\n    position: absolute;\r\n    right: 17px;\r\n}\r\n\r\n.v-slider-label.max {\r\n    bottom: 0px;\r\n}\r\n\r\n.v-slider-label.min {\r\n    top: 0px;\r\n}\r\n\r\n.h-slider {\r\n    width: 100px;\r\n    border: 1px solid #000;\r\n    height: 4px;\r\n    color: black;\r\n    margin-right: -5px;\r\n    position: relative;\r\n    left: 5px;\r\n    top: 75%;\r\n}\r\n\r\n.h-slider .handle {\r\n    position: absolute;\r\n    bottom: 100%;\r\n}\r\n\r\n.h-slider .handle img {\r\n    position: absolute;\r\n}\r\n\r\n.h-slider-tic {\r\n    position: absolute;\r\n    margin-top: -15px;\r\n    display: block;\r\n    width: 0px;\r\n    height: 4px;\r\n    border: 1px solid #000;\r\n}\r\n\r\n.h-slider-tic img {\r\n    position: absolute;\r\n}\r\n\r\n.h-slider-label {\r\n    position: absolute;\r\n    margin-top: -37px;\r\n}\r\n\r\n.h-slider-label.max {\r\n    right: 0px;\r\n}\r\n\r\n.h-slider-label.min {\r\n    left: 0px;\r\n}\r\n\r\n.websignature-position-top {\r\n    position: absolute;\r\n    top: 0;\r\n    width: 98%;\r\n    border-bottom: solid 1px #000000;\r\n}\r\n\r\n.websignature-position-bottom {\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 98%;\r\n    border-top: solid 1px #000000;\r\n}\r\n\r\n.varrow {\r\n    width: 0px;\r\n    height: 0px;\r\n    border-bottom: 7px solid transparent;\r\n    border-top: 7px solid transparent;\r\n    border-right: 12px solid #2f2f2f;\r\n    position: absolute;\r\n    border-radius: 5px;\r\n    left: 15%;\r\n    z-index: 10;\r\n    top: 5px;\r\n}\r\n\r\n.harrow {\r\n    width: 0px;\r\n    height: 0px;\r\n    border-right: 7px solid transparent;\r\n    border-left: 7px solid transparent;\r\n    border-bottom: 12px solid #2f2f2f;\r\n    position: absolute;\r\n    border-radius: 5px;\r\n    left: 0;\r\n    z-index: 10;\r\n    top: 0%;\r\n}\r\n\r\n\r\n/* Hidden Property Class Styles */\r\n\r\n.hiddenProp {\r\n    opacity: 0.5;\r\n}\r\n\r\n\r\n/* Style to be applied on the border of an invalid control */\r\n\r\n.outOfBounds {\r\n    overflow: hidden;\r\n    border: 3px dashed red !important;\r\n}\r\n\r\n\r\n/*\r\nBT - Start Changes\r\n*/\r\n\r\n.scroll-pane {\r\n    overflow: auto;\r\n    width: 99%;\r\n    float: left;\r\n    width: 4500px;\r\n}\r\n\r\n\r\n/*.scroll-content { width: 2440px; float: left; }*/\r\n\r\n.scroll-content-item {\r\n    width: 85px;\r\n    height: 40px;\r\n    float: left;\r\n    margin: 10px;\r\n    font-size: 14px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    border: solid 1px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.scroll-bar-wrap {\r\n    clear: left;\r\n    padding: 0 4px 0 2px;\r\n    margin: 0 -1px -1px -1px;\r\n}\r\n\r\n.scroll-bar-wrap .ui-slider {\r\n    background: none;\r\n    border: 0;\r\n    height: 2em;\r\n    margin: 0 auto;\r\n}\r\n\r\n.scroll-bar-wrap .ui-handle-helper-parent {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0 auto;\r\n}\r\n\r\n.scroll-bar-wrap .ui-slider-handle {\r\n    top: .2em;\r\n    height: 1.0em;\r\n    background: none;\r\n    background-color: #c0d382;\r\n}\r\n\r\n.scroll-bar-wrap .ui-slider-handle .ui-icon {\r\n    margin: -8px auto 0;\r\n    position: relative;\r\n    top: 50%;\r\n}\r\n\r\n#factories {\r\n    width: 100%;\r\n}\r\n\r\n.pf-control {\r\n    display: block;\r\n    position: absolute;\r\n}\r\n\r\n.pf-control-core {\r\n    cursor: default;\r\n    display: inline;\r\n    float: left;\r\n}\r\n\r\n.size-handle-top,\r\n.size-handle-bottom {\r\n    display: block;\r\n    height: 4px;\r\n    background-color: transparent;\r\n}\r\n\r\n.size-handle-bottom {\r\n    clear: both;\r\n}\r\n\r\n.size-handle-left,\r\n.size-handle-right {\r\n    display: inline;\r\n    width: 4px;\r\n    background-color: transparent;\r\n}\r\n\r\n.size-handle-left,\r\n.size-handle-right,\r\n.size-handle-top {\r\n    position: absolute;\r\n}\r\n\r\n.size-handle-left,\r\n.size-handle-top {\r\n    left: 0px;\r\n}\r\n\r\n.size-handle-bottom {\r\n    position: absolute;\r\n    bottom: 0px;\r\n}\r\n\r\n.size-handle-right {\r\n    right: 0px;\r\n}\r\n\r\n.drag-ghost {\r\n    border: 1px #111111 dashed;\r\n    background-color: transparent;\r\n    position: absolute;\r\n    left: -30000px;\r\n    top: -30000px;\r\n    z-index: 10000;\r\n}\r\n\r\n.propDetail {\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n    display: inline-block;\r\n}\r\n\r\n.propDetail label {\r\n    font-weight: normal;\r\n}\r\n\r\n#pageAssets {\r\n    position: fixed;\r\n    bottom: 0px;\r\n    left: 400px;\r\n    margin-bottom: 5px;\r\n    background: #fff;\r\n}\r\n\r\n.asset-control {\r\n    float: left;\r\n    padding: 5px;\r\n    text-align: center;\r\n    height: 50px;\r\n    width: 50px;\r\n}\r\n\r\n.asset-control label {\r\n    font-size: 10px;\r\n    font-weight: normal;\r\n}\r\n\r\n.asset-control:hover {\r\n    cursor: pointer;\r\n    background-color: #c0d382 !important;\r\n}\r\n\r\n.control-movie {\r\n    background: #000;\r\n}\r\n\r\n.prop-label {\r\n    font-weight: bold;\r\n}\r\n\r\n.prop-sublabel {\r\n    padding-top: 5px !important;\r\n}\r\n\r\n.prop-separator-radio {\r\n\tpadding-top: 0 !important; \r\n\tmax-height: 16px;\r\n}\r\n\r\n#propNavPosition div.nav-position.prop-detail input[type=\"text\"] {\r\n    width: 42px;\r\n}\r\n\r\n.add_overflow_y {/*\r\n\toverflow-y: auto;\r\n    overflow-x: hidden;*/\r\n}\r\n\r\nselect {\r\n    width: 100%;\r\n    height: 25px;\r\n    font-size: 11px;\r\n    font-size: 1.1rem;\r\n    background-color: #fff;\r\n    border-radius: 4px;\r\n    border: 1px solid #bbb;\r\n}\r\n\r\n\r\n/* Spectrum Override */\r\n\r\n.sp-preview {\r\n    position: relative;\r\n    width: 12px;\r\n    height: 21px;\r\n    border: solid 1px #222;\r\n    margin-right: 0px;\r\n    float: left;\r\n    z-index: 0;\r\n}\r\n\r\n.sp-replacer {\r\n    border-radius: 4px;\r\n    padding: 2px;\r\n}\r\n\r\n.sp-dd {\r\n    padding: 2px 0;\r\n    height: 16px;\r\n    line-height: 16px;\r\n    float: left;\r\n    font-size: 10px;\r\n    display: none;\r\n}\r\n\r\n.themeTextRows {\r\n    /* padding-left: 15px; */\r\n}\r\n\r\n.themeTextRows .style-font-size, .themeTextRows .style-border-size {\r\n    width: 41px !important;\r\n}\r\n\r\n.themeTextRows .style-font {\r\n    width: 80px;\r\n}\r\n\r\n.themeTextRows label {\r\n    font-weight: normal;\r\n}\r\n\r\n.weightSelector,\r\n.styleSelector {\r\n    border: 1px solid #bbb;\r\n    border-radius: 4px;\r\n    height: 32px;\r\n    width: 25px;\r\n}\r\n\r\n.themeTextRows .style-border-size,\r\n.themeTextRows .style-border-radius {\r\n    width: 50px;\r\n}\r\n\r\n.property-tabs .tab-pane {\r\n    width: 460px;\r\n}\r\n\r\n.ui-dialog {\r\n    z-index: 999999;\r\n}\r\n\r\n.ui-dialog-titlebar {\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n    /* IE6-9 */\r\n    border-top: 0px;\r\n    color: #fff;\r\n}\r\n\r\n.common-group-list {\r\n    width: 40%;\r\n    height: 480px;\r\n    padding: 0px;\r\n    border-radius: 4px;\r\n    -moz-border-radius: 4px;\r\n    -webkit-border-radius: 4px;\r\n    border: 1px solid #d5d5d5;\r\n    box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n    color: #333;\r\n    font-family: \"Roboto\", \"sans-serif\";\r\n    font-weight: 400;\r\n    overflow-y: auto;\r\n}\r\n\r\n.common-group-list ul {\r\n    padding: 0px;\r\n    margin: 2px;\r\n}\r\n\r\n.common-group-list li {\r\n    list-style-type: none;\r\n}\r\n\r\n.common-group-list li:hover,\r\n.search-item:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.common-group-list div,\r\n.search-item {\r\n    background: #fcfcfc;\r\n    background: -moz-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);\r\n    background: -webkit-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);\r\n    background: linear-gradient(to bottom, #fcfcfc 0%, #eeeeee 100%);\r\n    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee', GradientType=0);\r\n    border: 1px solid #d5d5d5;\r\n    box-shadow: 0px 2px 5px #d5d5d5;\r\n    -moz-box-shadow: 0px 2px 5px #d5d5d5;\r\n    -webkit-box-shadow: 0px 2px 5px #d5d5d5;\r\n    height: 25px;\r\n    padding: 4px;\r\n    font-size: 11px;\r\n}\r\n\r\nul.clone-helper > li {\r\n    list-style: none;\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n    border: 1px solid #d5d5d5;\r\n    width: 200px;\r\n    height: 35px;\r\n    padding: 4px;\r\n}\r\n\r\n.common-group-list div.selected\r\n{\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n.common-group-list div:hover,\r\n.search-item:hover {\r\n    background: #d8f1a8 !important;\r\n    background: -moz-linear-gradient(top, #d8f1a8 0%, var(--main-secondary) 100%) !important;\r\n    background: -webkit-linear-gradient(top, #d8f1a8 0%, var(--main-secondary) 100%) !important;\r\n    background: linear-gradient(to bottom, #d8f1a8 0%, var(--main-secondary) 100%) !important;\r\n}\r\n\r\n.thumb.ui-widget-header.selected {\r\n    border-radius: 4px;\r\n    outline: 1px dashed black;\r\n}\r\n\r\n.asset div.selected {\r\n    border-radius: 4px;\r\n    outline: 1px dashed black;\r\n}\r\n\r\n/* File Input */\r\n\r\n.inputfile {\r\n    width: 0.1px;\r\n    height: 0.1px;\r\n    opacity: 0;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    z-index: -1;\r\n}\r\n\r\n.inputfile+label {\r\n    width: 100%;\r\n    display: inline-block;\r\n    margin-bottom: 0;\r\n    font-weight: normal;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    touch-action: manipulation;\r\n    cursor: pointer;\r\n    background-image: none;\r\n    border: 1px solid transparent;\r\n    white-space: nowrap;\r\n    padding: 6px 12px;\r\n    font-size: 11px;\r\n    line-height: 1.42857143;\r\n    border-radius: 4px;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    background: #fcfcfc;\r\n    background: -moz-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);\r\n    background: -webkit-linear-gradient(top, #fcfcfc 0%, #eeeeee 100%);\r\n    background: linear-gradient(to bottom, #fcfcfc 0%, #eeeeee 100%);\r\n    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee', GradientType=0);\r\n    border: 1px solid #d5d5d5;\r\n    box-shadow: 0px 2px 5px #d5d5d5;\r\n    -moz-box-shadow: 0px 2px 5px #d5d5d5;\r\n    -webkit-box-shadow: 0px 2px 5px #d5d5d5;\r\n    color: #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.inputfile:focus+label,\r\n.inputfile+label:hover {\r\n}\r\n\r\n.inputfile+label {\r\n    cursor: pointer;\r\n    /* \"hand\" cursor */\r\n}\r\n\r\n.inputfile:focus+label {\r\n    outline: 1px dotted #000;\r\n    outline: -webkit-focus-ring-color auto 5px;\r\n}\r\n\r\n\r\n/* File Input */\r\n\r\n.list-group-item {\r\n    border: none;\r\n    padding: 5px 0px;\r\n}\r\n\r\n#report-form-dialog {\r\n    overflow: hidden;\r\n    padding-right: 0px;\r\n}\r\n\r\n#dbPanelOne ul,\r\n#dbPanelTwo ul {\r\n    margin: 0.75em 0;\r\n    padding: 0 1em;\r\n}\r\n\r\n#dbPanelOne>ul>li.list-group-item.node-dbPanelOne.node-selected,\r\n#dbPanelTwo>ul>li.list-group-item.node-dbPanelTwo.node-selected {\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n    border-top: 0px;\r\n    color: #fff!important;\r\n}\r\n\r\n#select-field-dialog .page-icon,\r\n#filterResults .page-icon {\r\n    margin-right: 10px;\r\n}\r\n\r\n#select-field-dialog ul {\r\n    margin: 0.75em 0;\r\n    padding: 0 1em;\r\n    list-style: none;\r\n}\r\n\r\n#select-field-dialog li.collapsible:before,\r\n#filterResults li.collapsible:before {\r\n    content: \"\";\r\n    width: 10px;\r\n    height: 10px;\r\n    border-right: 0;\r\n    border-top: 0.35em solid transparent;\r\n    border-left: 0.45em solid #000;\r\n    border-bottom: 0.35em solid transparent;\r\n    display: block;\r\n    left: -1em;\r\n    top: 1.1em;\r\n    position: relative;\r\n}\r\n\r\n#select-field-dialog li.collapsible.open:before,\r\n#filterResults li.collapsible.open:before {\r\n    border-bottom: 0;\r\n    border-left: 0.35em solid transparent;\r\n    border-right: 0.35em solid transparent;\r\n    border-top: 0.45em solid #000;\r\n}\r\n\r\n#select-field-dialog a.field-select.selected,\r\n#filterResults a.field-select.selected {\r\n    font-weight: bold;\r\n    color:  var(--main-primary);\r\n}\r\n\r\n#select-field-dialog a.field-list-toggle.selected {\r\n    font-weight: bold;\r\n    color:  var(--main-primary);\r\n}\r\n\r\n#dialog ul.select-list a.selected{\r\n    font-weight: bold;\r\n    color:  var(--main-primary);\r\n    text-decoration: underline;\r\n}\r\n\r\n.page-list.collapsible .control-list {\r\n    display: none;\r\n}\r\n\r\n.page-section a.selected {\r\n    color: #fff !important;\r\n}\r\n\r\n#select-field-dialog a:focus,\r\n#filterResults a:focus {\r\n    text-decoration: none;\r\n}\r\n\r\n#select-field-dialog a:hover,\r\n#filterResults a:hover {\r\n    text-decoration: none;\r\n    color:  var(--main-primary);\r\n}\r\n\r\n#filterResults a {\r\n    color: #000000;\r\n}\r\n\r\n.tt-dataset {\r\n    background: white;\r\n    width: 260px;\r\n    padding: 5px;\r\n    border-radius: 4px;\r\n    height: 200px;\r\n    border: 1px solid #d5d5d5;\r\n}\r\n\r\n.search-item i {\r\n    float: left;\r\n    margin-right: 5px;\r\n}\r\n\r\n.search-item div {\r\n    float: left;\r\n}\r\n\r\n#shared-settings-dialog .row {\r\n    margin: 10px 0;\r\n    padding: 0;\r\n}\r\n\r\n#propSharedSettingsLink a:hover {\r\n    cursor: pointer;\r\n}\r\n\r\nselect:disabled {\r\n    color: #bbb;\r\n}\r\n\r\ninput:disabled,\r\ntextarea:disabled {\r\n    background-color: #ddd;\r\n}\r\n\r\n#hideGrid,\r\n#designerNonVisualObjects,\r\n#designerObjectMarkers,\r\n#designerWorkflowMarkers,\r\n#designerSnapToGrid,\r\n#designerSnapTextToNeighbor,\r\n#designerToolbar,\r\n#designerPropertyBar,\r\n#designerHelpCenter,\r\n#designerHelpGuide,\r\n#designerObjectMarkers {\r\n    /* font-size: 11px; */\r\n}\r\n\r\n.tabs-label {\r\n    padding-left: 0px;\r\n    padding-top: 40px;\r\n}\r\n\r\n.nav-tabs.nav-right>li {\r\n    float: right;\r\n}\r\n\r\n.small-title>.ui-dialog-titlebar {\r\n    font-size: x-small;\r\n}\r\n\r\n.disabledLink {\r\n    color: grey !important;\r\n}\r\n\r\n.disabledPanel {\r\n    pointer-events: none;\r\n    opacity: 0.4 !important;\r\n}\r\n\r\n.disabledSection {\r\n    pointer-events: none;\r\n    opacity: 0.4;\r\n}\r\n\r\n.behavior-instance-tab {\r\n    float: left;\r\n    padding: 5px;\r\n    height: 30px;\r\n    min-width: 50px;\r\n    margin-left: 5px;\r\n    background: #fff;\r\n}\r\n\r\n.behavior-instance-tab.active {\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n    border-top: 0px;\r\n    color: #fff;\r\n}\r\n\r\n.behavior-instance-close-img {\r\n    float: right;\r\n    font-size: 8px;\r\n    cursor: pointer;\r\n    padding-left: 5px;\r\n}\r\n\r\n#behavior-tabs {\r\n    position: fixed;\r\n    bottom: 0px;\r\n    left: 400px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.ui-state-highlight,\r\n.ui-widget-content .ui-state-highlight,\r\n.ui-widget-header .ui-state-highlight {\r\n    border: 1px solid #67b021/*{borderColorHighlight}*/\r\n    !important;\r\n    background: #67b021/*{bgColorHighlight}*/\r\n    !important;\r\n    color: #363636/*{fcHighlight}*/\r\n    ;\r\n}\r\n\r\n#dialog-form .row {\r\n    margin: 3px 0;\r\n    padding: 0;\r\n}\r\n\r\n.formula-item {\r\n    font-size: 11px;\r\n}\r\n\r\n.formula-item.active,\r\n.formula-group.active,\r\n.formula-function.active {\r\n    background: #cecece;\r\n}\r\n\r\n.formula-item:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.formula-function-item {\r\n    font-style: italic;\r\n}\r\n\r\n.formula-function-item,\r\n.formula-function-item+div.formula-item {\r\n    margin-left: 15px;\r\n}\r\n\r\n.customized-text-area {\r\n    min-height: 40px !important;\r\n    font-size: smaller !important;\r\n    padding-right: 45px;\r\n}\r\n\r\n#property-tabs input.color-picker-text {\r\n    width: 55px;\r\n    padding-left: 1px !important;\r\n}\r\n\r\nli.object-selector:hover,\r\nli.behavior-selector:hover {\r\n    cursor: pointer;\r\n}\r\n\r\ntextarea {\r\n    resize: none;\r\n}\r\n\r\n#select-field-dialog ul {\r\n    font-size: 1.1rem;\r\n}\r\n\r\n.badges-container {\r\n    position: absolute;\r\n    left: -5px;\r\n    top: -5px;\r\n    opacity: 0.7;\r\n}\r\n\r\n.no-mobile-badge-container {\r\n    display: none;\r\n}\r\n\r\n.mobile-badge-container {\r\n    position: absolute;\r\n    left: 0;\r\n    top: -5px;\r\n    background:  var(--main-primary);\r\n    border-radius: 50%;\r\n    height: 20px;\r\n    width: 20px;\r\n    margin-top: 1px;\r\n    opacity: 0.7;\r\n    z-index: 999;\r\n}\r\n\r\n.badges-container ul {\r\n    list-style: none;\r\n}\r\n\r\n.badges-container ul li {\r\n    float: left;\r\n}\r\n\r\n.pf-badge.mobile-badge.mobile-badge-mandatory {\r\n     position: absolute;\r\n     width: 15px;\r\n     top: 3px;\r\n     left: 7px;\r\n}\r\n\r\n.pf-badge.mobile-badge.mobile-badge-normal {\r\n    position: absolute;\r\n    width: 15px;\r\n    top: 4px;\r\n    left: 3px;\r\n}\r\n\r\n\r\n.pf-badge.mobile-badge.mobile-badge-hidden {\r\n    position: absolute;\r\n    width: 15px;\r\n    top: 3px;\r\n    left: 3px;\r\n}\r\n\r\n.pf-badge.mobile-badge.mobile-badge-disabled {\r\n    position: absolute;\r\n    width: 15px;\r\n    top: 3px;\r\n    left: 4px;\r\n}\r\n\r\n.pf-badge.mobile-badge.mobile-badge-readonly {\r\n    position: absolute;\r\n    width: 15px;\r\n    top: 3px;\r\n    left: 4px;\r\n}\r\n\r\n.twitter-typeahead {\r\n    display: block;\r\n}\r\n\r\n.pf-selectable.group {\r\n    border: 0px transparent dashed;\r\n}\r\n\r\n.pf-selectable {\r\n    border: 0px transparent dashed;\r\n    overflow: hidden;\r\n}\r\n\r\n.pfSelected {\r\n    /* PF-3463: Image is being used instead of plain CSS classes due the following reason:\r\n      \"It was used to draw border with css for that select box,\r\n      but it was outside the rectangle caused by protruding select handles. \r\n      So it was opted to use the image.\"\r\n    */\r\n    /*border: 1px #111111 dashed !important;;*/\r\n    /*border: 1px solid;\r\n    border-image: -webkit-linear-gradient(left, #000, #FFF, #000 33%, #FFF, #000 66%, #000,#FFF,#000) 4%; \r\n    border-image: -ms-linear-gradient(left, #000, #FFF, #000 33%, #FFF, #000 66%, #000,#FFF,#000) 4%; \r\n    border-image: -moz-linear-gradient(left, #000, #FFF, #000 33%, #FFF, #000 66%, #000,#FFF,#000) 4%;*/\r\n    /*\r\n    border-style: solid !important;\r\n    border-width: 1px !important;\r\n    -moz-border-image: url(../images/common/resize-border.png) 8 8 repeat !important;\r\n    -webkit-border-image: url(../images/common/resize-border.png) 8 8 repeat !important;\r\n    -o-border-image: url(../images/common/resize-border.png) 8 8 repeat !important;\r\n    border-image: url(../images/common/resize-border.png) 8 8 repeat !important;\r\n    border: .1rem #000000 dashed !important;\r\n    */\r\n\r\n    /* PF-2381: Using outline instead of image for showing selected control's borders on editor layout */\r\n    outline: 1px dashed black;\r\n}\r\n\r\n.pfSelectedBlue, .nav-position input:focus, .prop-detail input:focus, .nav-position select:focus, .prop-detail select:focus {\r\n    border: 1px dodgerblue solid !important;\r\n}\r\n\r\n.pfSelected.reverseBorder {\r\n    border: 1px #ffffff dashed !important;\r\n}\r\n\r\n.wordwrap {\r\n    /* white-space: pre-wrap;*/\r\n    /* CSS3 */\r\n    white-space: -moz-pre-wrap;\r\n    /* Firefox */\r\n    white-space: -o-pre-wrap;\r\n    /* Opera 7 */\r\n    word-wrap: break-word;\r\n    /* IE */\r\n}\r\n\r\n#deleteFormulaItem:hover,\r\n#formulaUp:hover,\r\n#formulaDown:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n#thumb-pages li.selected>a,\r\n#document-1 li.selected>a,\r\ndiv.listSelected ul.select-list li.selected {\r\n    color:  var(--main-primary);\r\n    font-weight: bold;\r\n}\r\n\r\n#segrip {\r\n    right: -5px;\r\n    bottom: -5px;\r\n    height: 9px;\r\n    width: 9px;\r\n}\r\n\r\n.document-heading {\r\n    cursor: pointer;\r\n}\r\n\r\n#aPageSel {\r\n    position: absolute;\r\n    left: 0 ;\r\n    top: 0;\r\n}\r\n\r\n#aPage {\r\n    position: relative;\r\n    overflow: hidden;\r\n    -webkit-box-sizing: content-box;\r\n    -moz-box-sizing: content-box;\r\n    box-sizing: content-box;\r\n    border-style: solid;\r\n    border-width: 0px;\r\n    margin-bottom: 5px; \r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-top: 20px;\r\n}\r\n\r\n.formBoxShadow {\r\n    box-shadow: 5px 5px 5px #BBB;\r\n}\r\n\r\n\r\n\r\n\r\n#recentEdits .list li:hover, #recentEditsEFD .list li:hover, #recentEditsVFD .list li:hover, #favoriteForms .list li:hover {\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n.listSelected .list li:hover, #recentEditsEFD .list li:hover, #recentEditsVFD .list li:hover {\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n.inputTextWithLabel{\r\n    width: 42px !important;\r\n}\r\n\r\n.maskTextLabel{\r\n    width: 12px;\r\n    height: 16px;\r\n    text-align: center;\r\n}\r\n\r\n.maskTextLabelContainer{\r\n    padding-top: 3px ;\r\n    padding-left: 4px;\r\n}\r\n\r\n.no-spin-stepper::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {\r\n    -webkit-appearance: none !important;\r\n    margin: 0 !important;\r\n    -moz-appearance:textfield !important;\r\n}\r\n\r\n.table-ellipsis {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.search-results-ellipsis {\r\n    width: 100%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\ndiv.control-list-container, div.page-list.selected {\r\n    background: var(--main-primary) !important;\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n    border-top: 0px;\r\n    color: #fff!important;\r\n}\r\n\r\ndiv.page-list.selected > a.selected{\r\n    color:#fff!important;\r\n}\r\n\r\ndiv.control-list-container > a {\r\n    color: #fff!important;\r\n    font-weight: bold;\r\n    vertical-align: middle;\r\n}\r\n\r\nli.control-list-container > ul {\r\n    background-color: #fff;\r\n    margin-left: -10px!important;\r\n    margin-bottom: -1px!important;\r\n}\r\n\r\ndiv.control-list-container i {\r\n    padding-top: 2px;\r\n    padding-bottom: 1px;\r\n}\r\n\r\n.select-field-header{\r\n    padding-left: 5px;\r\n}\r\n\r\n.select-field-header.selected span{\r\n    color: #ffffff;\r\n}\r\n\r\n.selectedGroup{\r\n    color: var(--main-primary)!important;\r\n    font-weight: bold;\r\n}\r\n\r\n.control-list li {\r\n    padding-left: 4px !important;\r\n    padding-top: 1px;\r\n    padding-bottom: 1px;\r\n    vertical-align: middle !important;\r\n}\r\n\r\n.selected .field-select:hover {\r\n    color: #fff;\r\n}\r\n\r\n.field-list-toggle.field-select.selected{\r\n    color: #000000;\r\n}\r\n/* CLASSES FOR MOBILE VERSION*/\r\n\r\n.highlight {\r\n    font-weight: bold;\r\n    color: black;\r\n}\r\n.no-highlight {\r\n    font-weight: normal;\r\n    color: gray;\r\n}\r\n\r\n.large-icon {\r\n    font-size: 40px;\r\n    cursor: pointer;\r\n}\r\n\r\n.pf-section-control.pfSelected .pf-drag,\r\n.pf-section-control .pf-drag:hover {\r\n    color:  var(--main-primary) !important;\r\n}\r\n\r\n.ui-sortable-placeholder.ui-state-default {\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n\r\n.mobile-section-content .pf-control.control-container {\r\n    width: 100% !important;\r\n    height: calc(100% - 2px) !important;\r\n    top: inherit !important;\r\n    left: inherit !important;\r\n    display: inline-block;\r\n}\r\n\r\n.hideBodySection {\r\n    display: none !important;\r\n}\r\n\r\n.mobile-column-content {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.slide-placeholder {\r\n    background: linear-gradient(var(--gradient-ToBottom));\r\n    position: relative;\r\n}\r\n.slide-placeholder:after {\r\n    content: \" \";\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 15px;\r\n    background: transparent;\r\n}\r\n\r\n/* Datepicker styles */\r\n#aPage .ui-datepicker .ui-datepicker-header {\r\n\tposition: relative;\r\n\tpadding: .2em 0;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-prev,\r\n#aPage .ui-datepicker .ui-datepicker-next {\r\n\tposition: absolute;\r\n\ttop: 2px;\r\n\twidth: 1.8em;\r\n\theight: 1.8em;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-prev {\r\n\tleft: 2px;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-next {\r\n\tright: 2px;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-prev span,\r\n#aPage .ui-datepicker .ui-datepicker-next span {\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\tmargin-left: -8px;\r\n\ttop: 50%;\r\n\tmargin-top: -8px;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-title {\r\n\tmargin: 0 2.3em;\r\n\tline-height: 1.8em;\r\n\ttext-align: center;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-title select {\r\n\tfont-size: 1em;\r\n\tmargin: 1px 0;\r\n\theight: 25%;\r\n}\r\n#aPage .ui-datepicker select.ui-datepicker-month,\r\n#aPage .ui-datepicker select.ui-datepicker-year {\r\n\twidth: 45%;\r\n\tborder-radius: 0px! important;\r\n}\r\n#aPage .ui-datepicker table {\r\n\twidth: 100%;\r\n\tfont-size: .9em;\r\n\tborder-collapse: collapse;\r\n\tmargin: 0 0 .4em;\r\n\theight: 80%;\r\n}\r\n#aPage .ui-datepicker th {\r\n\tpadding: .7em .3em;\r\n\ttext-align: center;\r\n\tfont-weight: bold;\r\n\tborder: 0;\r\n}\r\n#aPage .ui-datepicker td {\r\n\tborder: 0;\r\n\tpadding: 1px;\r\n}\r\n\r\n#aPage .ui-datepicker .ui-datepicker-title {\r\n\tline-height: 3.3em !important;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-prev span, \r\n#aPage .ui-datepicker .ui-datepicker-next span {\r\n\ttop: 80% !important;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-prev {\r\n\tleft: 5px !important;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-next {\r\n\tright: 5px !important;\r\n}\r\n#aPage .ui-datepicker select.ui-datepicker-month {\r\n\twidth: 41% !important;\r\n\ttext-align: center;\r\n\tmargin: 3px;\r\n}\r\n#aPage .ui-datepicker select.ui-datepicker-year {\r\n\twidth: 45% !important;\r\n\ttext-align: center;\r\n\tmargin: 3px;\r\n}\r\n#aPage .ui-datepicker {\r\n\tpadding: 0;\r\n\tdisplay: none;\r\n\tbackground-color: white;\r\n\tfont-size: 9px;\r\n\tz-index: 16777271 !important;\r\n}\r\n#aPage .ui-datepicker .ui-datepicker-header {\r\n\tposition: relative;\r\n\tpadding: 0;\r\n\tbackground-color: #E3E3E3;\r\n\tborder-radius: 0 0 0 0;\r\n\tborder-style: none none solid;\r\n\tborder-width:\r\n\t0 0 1px; \r\n}\r\n#aPage .dateCalendar .ui-datepicker-calendar a, \r\n#aPage .dateinputpicker .ui-datepicker-calendar a {\r\n\tborder: none;\r\n\tbackground: #ffffff;\r\n}\r\n#aPage .ui-datepicker th {\r\n\tfont-family:Sans-Serif;\r\n\tfont-size:11px;\r\n}\r\n#aPage .ui-datepicker td {\r\n\tpadding: 0px !important;\r\n}\r\n#aPage .ui-datepicker {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder-bottom: none;\r\n\tbackground-color: #ffffff;\r\n\tcolor: #333333;\r\n\tborder: none;\r\n}\r\n#aPage .ui-datepicker th {\r\n\tline-height: 16px;\r\n\tfont-size: 10px !important;\r\n\tfont-family: sans-serif !important;\r\n\tcolor: #333333;\r\n\tbackground-color: transparent;\r\n\tpadding: 2px!important;\r\n}\r\n\r\n#aPage .ui-datepicker select.ui-datepicker-month,\r\n#aPage .ui-datepicker select.ui-datepicker-year {\r\n\tcolor: #333333;\r\n\tfont-family: sans-serif !important;\r\n}\r\n#aPage .ui-datepicker td span,\r\n#aPage .ui-datepicker td a {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #333333;\r\n\tfont-size: 10px!important;\r\n\tfont-family: sans-serif !important;\r\n\tfont-weight: normal !important;\r\n\tline-height: 16px;\r\n\ttext-align: center;\t\r\n\tborder: 0 !important;\r\n}\r\n\r\n#aPage .ui-datepicker td a.ui-state-highlight {\r\n    background-color: #f89b3c !important;\r\n}\r\n/* End of Datepicker styles */\r\n\r\n\r\n/* MODAL DIALOGS */\r\n\r\n.dialog-container{\r\n    padding: 10px 5px 10px 5px !important;\r\n    border: 1px solid #ccc !important;\r\n    border-width: thin !important;\r\n    border-radius: 10px !important;\r\n    box-shadow: 0 2px 9px rgba(0,0,0,.4) !important;\r\n}\r\n\r\n\r\n/* GREETING MODAL */\r\n\r\n#dialog-greeting{\r\n    padding: 20px 20px 10px 20px!important;\r\n}\r\n\r\n#dialog-greeting .welcome-options{\r\n\tpadding: 15px; \r\n    text-align: center;\r\n    box-shadow: 0 2px 9px rgba(0,0,0,.4) !important;\r\n    border-radius: 25px;\r\n    height: 225px;\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n    cursor:pointer;\r\n    transition: box-shadow 300ms ease-in-out;\r\n}\r\n\r\n#dialog-greeting .welcome-options:hover{\r\n    box-shadow: 0 2px 12px var(--main-primary) !important;\r\n}\r\n\r\n#dialog-greeting .row{\r\n    margin: 0!important;\r\n}\r\n\r\n.greeting-button {\r\n    border-bottom-style: double;\r\n    border-right-style: double;\r\n    border-color:#f0fdff;\r\n    border-radius: 15px;\r\n    background-color: var(--mobile-buttons);\r\n    color: white;\r\n    width: 100px;\r\n    margin-top: 10px;\r\n    height: 25px;\r\n    box-shadow: 1px 1px 1px #888888;\r\n    float: right;\r\n    font-size: 12px;\r\n    padding-top: 3px;\r\n}\r\n\r\n.greeting-button h5{\r\n    margin-bottom: 0px;\r\n    font-size: 13px;\r\n    margin-top: 0px;\r\n    \r\n}\r\n.greeting-button-column{\r\n    text-align: center;\r\n}\r\n\r\n.greeting-container {\r\n    display: flex; \r\n    align-items: center; \r\n    justify-content: center;\r\n    width: 100%;\r\n    margin: 0 auto; \r\n    padding-bottom: 20px; \r\n    margin-top: 25px;\r\n}\r\n\r\n.greeting-container img {\r\n    width: 80px;    \r\n    height: 80px;\r\n    cursor: pointer\r\n}\r\n\r\n/* TRIAL EXPIRED MODAL */\r\n\r\n.trial-request-button {\r\n    color: white;\r\n    width: 145px;\r\n    margin-top: 10px;\r\n    height: 37px;\r\n    margin: auto;\r\n    font-size: 12px;\r\n    display: block;\r\n    font-weight: bold;\r\n    border-radius: 5px;\r\n    border: 1px solid #F89B3C;\r\n    background: #F89B3C;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.trial-back-button {\r\n    color: black;\r\n    width: 145px;\r\n    margin-top: 10px;\r\n    height: 37px;\r\n    margin: auto;\r\n    font-size: 12px;\r\n    display: block;\r\n    font-weight: bold;\r\n    border-radius: 5px;\r\n    border: 1px solid #f0f0f0;\r\n    background: #f0f0f0;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.trial-expired-button-container {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.trial-expired-link {\r\n    color: #f99f4b !important;\r\n    font-weight: bold;\r\n}\r\n\r\n/* HELP CENTER */\r\n\r\n#dialog-help-center{\r\n    padding: 10px 5px 10px 5px !important;\r\n    border: 1px solid #ccc !important;\r\n    border-width: thin !important;\r\n    border-radius: 10px !important;\r\n    box-shadow: 0 2px 9px rgba(0,0,0,.4) !important;\r\n\r\n}\r\n\r\n#dialog-help-center .inner-container-help{\r\n    padding: 0 5px 5px 5px !important;\r\n    margin: 10px !important;\r\n}\r\n\r\n#dialog-help-center .title_help_center {\r\n    margin-bottom: 25px !important;\r\n    font-size: 2.5rem !important;\r\n    text-align: left !important;\r\n    font-size: 12px !important;\r\n    font-weight: 500 !important;\r\n    color: #333 !important;\r\n    \r\n}\r\n\r\n#dialog-help-center .title-bar {  \r\n    font-weight: 500 !important;\r\n}\r\n\r\n#helpContent{\r\n    margin: 0px !important;\r\n}\r\n\r\n#helpContent .title-bar, .title-bar, .inner-container-help .title-bar{\r\n\r\n    background-image: -moz-linear-gradient(var(--gradient)) !important;\r\n    background-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n    background-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n  \r\n    border-radius: 5px;\r\n    color: #fff !important;\r\n    font-size: 20px !important;\r\n    padding: 5px 0 5px 20px !important;\r\n    width: 100%;\r\n    font-family:\"Roboto\", \"sans-serif\";\r\n    margin-top: 15px !important;\r\n    margin-bottom: 15px !important;\r\n}\r\n.helpCenterDialog{\r\n    border:0 !important;\r\n    padding: 0 !important;\r\n    border-radius: 10px;\r\n}\r\n.help-center{\r\n    font-size: 12px;\r\n}\r\n.help-center button.greeting-button{\r\n    width: 100px !important;\r\n    margin: 0;\r\n    height: 25px !important;\r\n}\r\n\r\n.sub_topic_help{\r\n    font-weight: 700 !important;\r\n    font-size: 14px !important;\r\n    font-style:normal !important;\r\n    font-family: \"Roboto\", \"sans-serif\" !important;\r\n    text-align: left !important;\r\n    color: #333 !important;\r\n}\r\n\r\n#helpContent svg{\r\n    width: 23px;\r\n    height: 19px;\r\n    fill: var(--main-primary) ;\r\n    cursor: pointer;\r\n}\r\n\r\n#helpContent .link{\r\n    margin-left:20px!important;\r\n}\r\n\r\n.layout-toolbar-pane-label{\r\n    margin-top: -5px;\r\n    font-size: 0.4em;\r\n    font-weight: 500;\r\n}\r\n\r\n.inline-help{\r\n    width: 20px;\r\n    display: inline-flex;\r\n    padding: 5px 7px 5px 8px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 50px;\r\n    border: 2px solid #F89B3C;\r\n    height: 20px;\r\n    margin: 0 5px;\r\n    color: #F89B3C;\r\n    font-weight: bolder;\r\n    font-size: 15px;\r\n    cursor: pointer;\r\n}\r\n\r\n/* Tooltip container */\r\n.pa-tooltip {\r\n    position: relative;\r\n}\r\n  \r\n  /* Tooltip text */\r\n  .pa-tooltip .tooltiptext {\r\n    visibility: hidden;\r\n    width: 250px;\r\n    color: #000;\r\n    text-align: left;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    border: 2px solid var(--accent-color);\r\n    background: #FFF;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n    bottom: 25px;\r\n    left: 50%;\r\n    margin-left: -125px; /* Use half of the width, to center the tooltip */\r\n    position: absolute;\r\n    z-index: 1;\r\n    font-weight: normal;\r\n    font-family: Poppins;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  /* Show the tooltip text when you mouse over the tooltip container */\r\n  .pa-tooltip:hover .tooltiptext {\r\n    visibility: visible;\r\n  }\r\n\r\n  /* bottom arrow */\r\n  .pa-tooltip .tooltiptext::after {\r\n    content: \" \";\r\n    position: absolute;\r\n    top: 100%; /* At the bottom of the tooltip */\r\n    left: 50%;\r\n    margin-left: -5px;\r\n    border-width: 5px;\r\n    border-style: solid;\r\n    border-color: var(--accent-color) transparent transparent transparent;\r\n  }\r\n#activeBehaviors{\r\n    height:0px; \r\n    background-color: #F4F4F4; \r\n    margin-top: 3px;\r\n}\r\n\r\n.current-behavior{\r\n    color: #808080;\r\n    font-family: 'Roboto';\r\n    margin: 8px 10px;\r\n    font-weight: 500;\r\n}\r\n\r\n\r\n\r\n.behaviors-list{\r\n    min-width: 200px;\r\n    height: auto;\r\n    background-color: #F9F9F9;\r\n    position: absolute;\r\n    bottom: 44px;\r\n    right: 14px;\r\n    float: right;\r\n    display: none;\r\n    z-index: 90000;\r\n    padding: 10px;\r\n    border-radius: 5px 5px 0px 5px;\r\n    border: 1px solid #D6D6D6;\r\n    max-height: 60vh;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n}\r\n\r\n#activeBehaviorsButton{\r\n    display: none;\r\n}\r\n\r\n.activeBehaviors{\r\n    cursor: pointer;\r\n    width: 40px;\r\n    float: right;\r\n    border-radius: 5px;\r\n    margin-right: 2px;\r\n    padding: 0 12px;\r\n    margin-top: -2px;\r\n}\r\n\r\n.activeBehaviors span{\r\n    font-size: 2.8em;\r\n    rotate: 90deg;\r\n    text-shadow: 0 1px 2px rgba(0,0,0,.6);\r\n    margin-top: -2px;\r\n}\r\n\r\n.activeBehaviors.active{\r\n    color: white;\r\n\tbackground: var(--main-primary) !important;\r\n\tbackground-image: -moz-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n.activeBehaviors:hover{\r\n    color: white;\r\n\tbackground: var(--main-primary) !important;\r\n\tbackground-image: -moz-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n.behavior-item{\r\n    min-width: 315px;\r\n    height: 62px;\r\n    background: #F4F4F4;\r\n    padding: 10px;\r\n    color: #2D2D2D;\r\n    font-family: Poppins;\r\n    margin: 5px 0;\r\n    border-radius: 5px;\r\n   \r\n}\r\n\r\n.behavior-item .behavior-name{\r\n    font-weight: 500;\r\n}\r\n\r\n.behavior-item .behavior-breadcrumb{\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    color: #898989;\r\n}\r\n\r\n.behavior-item:hover{\r\n    background: #EEE;\r\n    cursor: pointer;\r\n   \r\n}\r\n.behaviors-list .close-behaviors{\r\n    margin: 10px 5px;\r\n    text-align: right;\r\n    color: #799F3F;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n}\r\n\r\n.behaviors-list .close-behaviors:hover{\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n}\r\n\r\n.behaviors-list .close-icon{\r\n    text-align: right;\r\n    float: right;\r\n    display: none;\r\n}\r\n\r\n.behavior-item:hover .close-icon {\r\n    display: block;\r\n}\r\n\r\n.behaviorLinkToDesigner{\r\n    cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
